// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"447":"115c7dfe","967":"6d20d79f"}[chunkId] + ".chunk.js";
};